var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.6,
    height: 15,
    viewBox: "0 0 13.6 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#1d0e3d;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.9,6h9.8a1.4,1.4,0,0,1,1.4,1.4v9.8a1.4,1.4,0,0,1-1.4,1.4H5.9a1.4,1.4,0,0,1-1.4-1.4V7.4A1.4,1.4,0,0,1,5.9,6Z",
    transform: "translate(0 -1.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,3V5.8",
    transform: "translate(-10.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,3V5.8",
    transform: "translate(-4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.5,15H17.1",
    transform: "translate(0 -6.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherCalendar);
export default __webpack_public_path__ + "static/media/feather-calendar.89a293a92153fbda7cef3617c9b31ce2.svg";
export { ForwardRef as ReactComponent };